import { render, staticRenderFns } from "./PackageSearch.vue?vue&type=template&id=5e458344&scoped=true"
import script from "./PackageSearch.vue?vue&type=script&lang=js"
export * from "./PackageSearch.vue?vue&type=script&lang=js"
import style0 from "./PackageSearch.vue?vue&type=style&index=0&id=5e458344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e458344",
  null
  
)

export default component.exports